export const LicenceStatusFactory = () => {
    return function LicenceStatus() {

        this.id = null;
        this.code = null;
        this.name = null;
    };
};
